module.exports = __webpack_public_path__ + "img/worksbot_img20022508.3c0c3338.jpg";